// Conectores de ERP do embarcador (épico PO1-3614, H3/H4) — endpoints do
// backend_hub em /embarcadores/:embarcadorId/conectores-erp. Usar `api`
// (API_URL): o interceptor injeta o X-Active-Embarcador-Id. O backend confere
// o embarcador em todas as rotas (403 fora do escopo) e esconde do cliente os
// conectores só de admin (ex.: erp-homologacao).
//
//   GET  /conectores-erp
//        → [{ conectorKey, nome, categoria, direcao,
//             versoes: [{ versao, idConector, capacidades: ['nfe', ...] }],
//             situacao: { status: 'nao_configurado'|'ativo'|'agendado',
//                         vigente: { id, versao, vigenciaInicio, vigenciaFim }|null,
//                         agendado: { id, versao, vigenciaInicio }|null } }]
//   GET  /conectores-erp/:key/campos?versao=
//        → { conectorKey, versao, idConector, idVinculo, situacao,
//            campos: ParametroFormulario[] + ehCapacidade } (senha: valor null + hasValue)
//   GET  /conectores-erp/:key/historico
//        → [{ id, versao, vigenciaInicio, vigenciaFim,
//             status: 'vigente'|'agendado'|'encerrado'|'desativado', criadoPor, alteradoPor, ... }]
//   PUT  /conectores-erp/:key  { versao, vigenciaInicio?, valores: [{ idParametro, valor }] }
//        → { ok, idVinculo, versao, criado, gravados, removidos, mantidos }
//        Senha com '' mantém a salva; demais vazios apagam; fora da versão → 400 { rejeitados }.
//   POST /conectores-erp/:key/trocar-versao { versao, vigenciaInicio, valores? }
//   POST /conectores-erp/:key/cancelar-agendamento
//   POST /conectores-erp/:key/desativar
//   POST /conectores-erp/:key/testar { versao, valores: { nome: valor } }
//        → sempre 200 { ok, mensagem, duracaoMs }
//   GET  /conectores-erp/bling/autorizar (PO1-3848)
//        → { url } da autorização OAuth no Bling com `state` assinado; a página inteira
//          vai até lá e volta em /app/integracoes?conector=bling&status=ok|erro&msg=.
//          409 sem aplicativo configurado na Everlog ou sem vínculo bling aberto.
//   GET  /conectores-erp/:key/autorizar (PO1-3853, conectores com OAuth; 1º uso: Tiny)
//        → { url, redirectUri } da autorização OAuth no provedor com `state` assinado; a
//          página inteira vai até lá e volta em /app/integracoes?conector=<key>&status=ok|erro&msg=.
//          404 chave sem OAuth; 409 sem vínculo aberto; 400 sem a credencial do aplicativo salva.
import api from "./api";

const base = (embarcadorId) => `/embarcadores/${embarcadorId}/conectores-erp`;

export async function listarConectoresErp(embarcadorId) {
  const { data } = await api.get(base(embarcadorId));
  return Array.isArray(data) ? data : [];
}

export async function getCamposConectorErp(embarcadorId, conectorKey, versao) {
  const { data } = await api.get(`${base(embarcadorId)}/${conectorKey}/campos`, { params: versao ? { versao } : {} });
  return data;
}

export async function getHistoricoConectorErp(embarcadorId, conectorKey) {
  const { data } = await api.get(`${base(embarcadorId)}/${conectorKey}/historico`);
  return Array.isArray(data) ? data : [];
}

export async function salvarConectorErp(embarcadorId, conectorKey, { versao, vigenciaInicio, valores }) {
  const { data } = await api.put(`${base(embarcadorId)}/${conectorKey}`, { versao, vigenciaInicio: vigenciaInicio || undefined, valores: valores || [] });
  return data;
}

export async function trocarVersaoConectorErp(embarcadorId, conectorKey, { versao, vigenciaInicio, valores }) {
  const { data } = await api.post(`${base(embarcadorId)}/${conectorKey}/trocar-versao`, { versao, vigenciaInicio, valores: valores || [] });
  return data;
}

export async function cancelarAgendamentoConectorErp(embarcadorId, conectorKey) {
  const { data } = await api.post(`${base(embarcadorId)}/${conectorKey}/cancelar-agendamento`);
  return data;
}

export async function desativarConectorErp(embarcadorId, conectorKey) {
  const { data } = await api.post(`${base(embarcadorId)}/${conectorKey}/desativar`);
  return data;
}

export async function testarConectorErp(embarcadorId, conectorKey, versao, valores) {
  const { data } = await api.post(`${base(embarcadorId)}/${conectorKey}/testar`, { versao, valores: valores || {} });
  return data;
}

export async function obterUrlAutorizacaoBling(embarcadorId) {
  const { data } = await api.get(`${base(embarcadorId)}/bling/autorizar`);
  return data && data.url ? String(data.url) : "";
}

export async function obterUrlAutorizacaoConectorErp(embarcadorId, conectorKey) {
  const { data } = await api.get(`${base(embarcadorId)}/${conectorKey}/autorizar`);
  return {
    url: data && data.url ? String(data.url) : "",
    redirectUri: data && data.redirectUri ? String(data.redirectUri) : "",
  };
}
